import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { CardsEventType } from '../cards.event.type';
import { Card } from '../model/card';
import { TweenMax, Quint } from 'gsap';
import { SharedService } from '../../../shared/shared.service';
import { EventTypes } from '../../../shared/EventTypes';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Auth } from '../../../autentication/Auth';
import { CardsService } from '../cards.service';

@Component({
	selector: 'app-change-pass',
	templateUrl: './change-pass.component.html',
	styleUrls: ['./change-pass.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ChangePassComponent implements OnInit {

	@Input() submited = false;
	@Input() cardData: Card;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() setTitle: EventEmitter<any> = new EventEmitter<any>();

	public activeBackButton = false;
	public formPass: FormGroup;
	public formSignature: FormGroup;
	public inputToResetPass: any;
	public active = false;
	public disabled = false;
	private view = '[data-component="change-pass"]';
	private viewHeight = 0;

	constructor(private formBuilder: FormBuilder, private autenticationService: AutenticationService, private cardsService: CardsService) {
		this.formPass = formBuilder.group({
			passwords: this.formBuilder.group({
				password: ['', [Validators.required]],
				repeatPassword: ['', [Validators.required]],
			}, { validator: this.passwordConfirming }),
		});

	}


	ngOnInit() {

		AppEventDispatcher.listen(CardsEventType.STEPS.CHANGE_PASS, data => {
			if (data.show) {
				this.active = true;
				this.setForm.emit(this.formPass);
				this.setTitle.emit({
					title: 'Alterar senha do cartão',
				});
				this.show();
			} else {
				this.hide();
			}
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(CardsEventType.STEPS.CHANGE_PASS);
	}

	show() {
		TweenMax.delayedCall(.6, () => {
			const containerHeight = $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });
		});
	}

	addAuthToken() {
		Auth.passToken = this.formSignature.value.token ? this.formSignature.value.token : '';
		Auth.assinaturaEletronica = this.formSignature.value.eletronicSignature ? this.formSignature.value.eletronicSignature : '';
	}

	hide() {

		this.preload(true);
		this.disabled = true;
		this.addAuthToken();

		this.autenticationService.sendDigitalSignature(this.formSignature.value.eletronicSignature).subscribe(pass => {

			if (pass.Sucesso) {

				this.preload(true);
				let time = 1;
				const timeLoader = setInterval(() => {
					time++;
				}, 1000);


				this.cardsService.changePassword(this.cardData).subscribe(data => {

					this.cardData.message = data.Mensagem;
					this.cardData.success = data.Sucesso;

					if (time > 3) {
						this.preload(false);
						this.disabled = false;
						this.hideAfterSend();
					} else {
						TweenMax.delayedCall(3 - time, () => {
							this.preload(false, 3 - time);
							this.disabled = false;
							this.hideAfterSend();
						});
					}
					clearInterval(timeLoader);

				}, error => {

					if (time > 3) {
						this.preload(false);
					} else {
						TweenMax.delayedCall(3 - time, () => {
							this.preload(false, 3 - time);
						});
					}

					this.disabled = false;
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
					clearInterval(timeLoader);
				});

			}

		}, error => {
			this.preload(false);
			this.disabled = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});


	}

	passwordConfirming(c: AbstractControl): { invalid: boolean } {
		if (c.get('password').value !== c.get('repeatPassword').value) {
			return { invalid: true };
		}
	}

	keyDownHandler(event: Event) {
		event.preventDefault();
	}

	setInput(input) {
		this.inputToResetPass = this.formPass.get(['passwords', input]);
	}

	setInputValueFromKeyPad(val) {
		if (this.inputToResetPass.value.length <= 3) {
			this.inputToResetPass.setValue(this.inputToResetPass.value.toString() + val[0].toString());
		}
	}

	onSetSignatureForm(form: FormGroup) {
		this.formSignature = form;
	}

	changeToRepeatPass() {
		if (this.formPass.get(['passwords', 'password']).value && !this.formPass.get(['passwords', 'repeatPassword']).value) {
			$('.reset-pass').find('.repeat-password').focus();
		}
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '.reset-pass .content', show: active, delay: delay });
	}
	onCorrect() {
		this.inputToResetPass.setValue('');
	}

	showNumPad(e) {
		this.hideNumPad(e);
		TweenMax.to('.reset-pass [data-component="virtual-num-pad"]', .5, { autoAlpha: 1 });
	}

	hideNumPad(e) {
		if (e.relatedTarget === null || e.relatedTarget.className !== 'keyboard-button') {
			TweenMax.to('.reset-pass [data-component="virtual-num-pad"]', .5, { autoAlpha: 0 });
		}
	}

	hideAfterSend() {
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(CardsEventType.STEPS.LIST_CARDS, { show: true });
			TweenMax.to(this.view, .8, {
				left: '-100%', ease: Quint.easeOut, onComplete: () => {
					this.active = false;
				}
			});
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/cards/change-pass/change-pass.component.ts